import { QueryColumn } from "query/QueryColumn";
import { Row } from "table/Row";
import { Cell, CellType } from "table/Cell";

/* To use me:

let source : Array<Row> = ...;
let sink : Array<Row> = [];
for (let eachRow of source) {
    let it = new CollectionIterator(queryColumn, eachRow, 0);
    while (it.nextInto(sink));
}
*/

export abstract class ExpanderIterator {
    // Whether I cannot return any more rows at all.
    protected _isExhausted: boolean = true; // the first iteration should replenish me.

    protected _column: QueryColumn;
    protected _columnIndex: number; // Index into the Row[].

    constructor(column: QueryColumn, columnIndex: number) {
        this._column = column;
        this._columnIndex = columnIndex;
    }

    /* Expand the source and write to the given accumulator. Return true on success. Return false if there are 
    no more results. If false is returned, then the accumulator will be 
    unhelpfully repopulated with the previous result and should be ignored. */
    public abstract nextInto: (accumulator: Row) => void;

    /* I will keep iterating until all of my children are exhausted. */
    public abstract isExhausted: () => boolean;

    /** When one of my sub-iterators is exhausted, it can be given fresh data from the parent. */
    public abstract replenishWith: (source: Cell) => void;

    /** Called instead of replenishWith when no data was found in the source. */
    public abstract noDataAvailable : () => void;
}